/** Fixed bottom tab bar height (matches BottomTabNavigator tabBarStyle). */
export const MOBILE_TAB_BAR_HEIGHT = 65;
/** Extra padding below tab icons (matches tour / home tooltip offsets). */
export const MOBILE_TAB_BAR_EXTRA = 10;

/** Bottom offset so floating UI (e.g. toasts) sits above the tab bar. */
export function getBottomOffsetAboveTabBar(
  bottomInset: number,
  gap = 12
): number {
  return MOBILE_TAB_BAR_HEIGHT + bottomInset + MOBILE_TAB_BAR_EXTRA + gap;
}

/** Maps dashboard feature routes to bottom-tab screen names on mobile. */
export const MOBILE_FEATURE_TAB_MAP: Record<string, string> = {
  ColourAnalysis: 'ColourAnalysisMobile',
  VirtualDrapeTest: 'VirtualDrapeTestMobile',
  ColorGenerator: 'ColorGeneratorMobile',
  ColorLibrary: 'ColorLibraryMobile',
};

export function getMobileTabForRoute(route: string): string | null {
  return MOBILE_FEATURE_TAB_MAP[route] ?? null;
}

/** Home sidebar/tab press should reset embedded home sub-views (cards → feature). */
export function shouldResetHomeSubContent(tab: string): boolean {
  return tab === 'HomeTab';
}
